<div class="row">
  <p class="error">{{error_message}}</p>
</div>
<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>

 

<blockquote>
    <h5 class="headings">HEALTH & SAFETY</h5>
</blockquote>
<form>
    <h6 class="instructions">
        <span style="font-weight: 800;">Critical or high-risk work</span> involves but not limited to tasks that significantly impact safety, security, or
        operations, including activities with hazardous materials, high-pressure systems, or confined spaces.
        <br><br>
        All Contractors and Sub-Contractors who wish to perform critical or high-risk work for UNIPET or its subsidiaries must be assessed before being awarded a contract for work. Do you have:
    </h6>
    <br>
    <div class="card">
        <div class="radio-row">
          <h6>1. Evidence of safe work practices, which include but are not limited to, a documented HSE policy and arrangements for safe work.</h6>
          <div class="radio-options">
            <label>
              <input name="group1" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasSafetyFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">Yes</span>
            </label>
            <label>
              <input name="group1" type="radio" [value]="'no'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasSafetyFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">No</span>
            </label>
            <label>
              <input name="group1" type="radio" [value]="'na'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasSafetyFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">NA</span>
            </label>
          </div>
        </div>
        <div *ngIf="!isViewOnly && hse_docs.hasSafetyFile === 'yes'">
          <br>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label><br>
          <label class="custom-file-upload">
            Upload
            <i class="tiny icon-inline material-icons">file_upload</i>
            <input type="file" (change)="onFileSelected($event, 'safe')">
          </label>
          <p *ngIf="hse_docs.safetyFile || hse_docs.safetyFilePath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="hse_docs.safetyFile">{{ hse_docs.safetyFile.name }}</span>
            <span *ngIf="!hse_docs.safetyFile && hse_docs.safetyFilePath">
                <a 
                  [href]="'data:application/pdf;base64,' + hse_docs.safetyFileData" 
                  [download]="hse_docs.safetyFilePath" 
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #079AFE;"
                >
                  {{ hse_docs.safetyFilePath }}
                </a>
              </span>
          </p>
        </div>

        <div *ngIf="isViewOnly && hse_docs.safetyFileData && hse_docs.safetyFilePath">
          <p>
            Safety File: 
            <a 
              [href]="'data:application/pdf;base64,' + hse_docs.safetyFileData"
              [download]="hse_docs.safetyFileData" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ hse_docs.safetyFilePath }}
            </a>
          </p>
        </div>
    </div>
    <div class="card">
        <div class="radio-row">
          <h6>2. Proof of relevant training of employees</h6>
          <div class="radio-options">
            <label>
              <input name="group2" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasTrainingFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">Yes</span>
            </label>
            <label>
              <input name="group2" type="radio" [value]="'no'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasTrainingFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">No</span>
            </label>
            <label>
                <input name="group2" type="radio" [value]="'na'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasTrainingFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
                <span class="radio">NA</span>
              </label>
          </div>
        </div>
        <div *ngIf="!isViewOnly && hse_docs.hasTrainingFile === 'yes'">
          <br>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label><br>
          <label class="custom-file-upload">
            Upload
            <i class="tiny icon-inline material-icons">file_upload</i>
            <input type="file" (change)="onFileSelected($event, 'training')">
          </label>
          <p *ngIf="hse_docs.trainingFile || hse_docs.trainingFilePath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="hse_docs.trainingFile">{{ hse_docs.trainingFile.name }}</span>
              <span *ngIf="!hse_docs.trainingFile && hse_docs.trainingFilePath">
                  <a 
                    [href]="'data:application/pdf;base64,' + hse_docs.trainingFileData" 
                    [download]="hse_docs.trainingFilePath" 
                    target="_blank"
                    rel="noopener noreferrer"
                    style="color: #079AFE;"
                  >
                    {{ hse_docs.trainingFilePath }}
                  </a>
                </span>
            </p>
          </div>

          <div *ngIf="isViewOnly && hse_docs.trainingFileData && hse_docs.trainingFilePath">
            <p>
              Training File: 
              <a 
                [href]="'data:application/pdf;base64,' + hse_docs.trainingFileData" 
                [download]="hse_docs.trainingFileData" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
                >
                {{ hse_docs.trainingFilePath }}
              </a>
            </p>
          </div>
      </div>
    <div class="card">
        <div class="radio-row">
          <h6>3. Documentation of resources allocated to HSE performance</h6>
          <div class="radio-options">
            <label>
              <input name="group3" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasResourcesFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">Yes</span>
            </label>
            <label>
              <input name="group3" type="radio" [value]="'no'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasResourcesFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">No</span>
            </label>
            <label>
                <input name="group3" type="radio" [value]="'na'" [disabled]="isViewOnly" [(ngModel)]="hse_docs.hasResourcesFile" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
                <span class="radio">NA</span>
              </label>
          </div>
        </div>
        <div *ngIf="!isViewOnly && hse_docs.hasResourcesFile === 'yes'">
          <br>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label><br>
          <label class="custom-file-upload">
            Upload
            <i class="tiny icon-inline material-icons">file_upload</i>
            <input type="file" (change)="onFileSelected($event, 'resources')">
          </label>
          <p *ngIf="hse_docs.resourcesFile || hse_docs.resourcesFilePath" style="color: #E65F53;">
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="hse_docs.resourcesFile">{{ hse_docs.resourcesFile.name }}</span>
            <span *ngIf="!hse_docs.resourcesFile && hse_docs.resourcesFilePath">
              <a [href]="'data:application/pdf;base64,' + hse_docs.resourcesFileData" [download]="hse_docs.resourcesFilePath"
                target="_blank" rel="noopener noreferrer" style="color: #079AFE;">
                {{ hse_docs.resourcesFilePath }}
              </a>
            </span>
          </p>
        </div>

        <div *ngIf="isViewOnly && hse_docs.resourcesFileData && hse_docs.resourcesFilePath">
          <p>
            Resources File: 
            <a 
              [href]="'data:application/pdf;base64,' + hse_docs.resourcesFileData" 
              [download]="hse_docs.resourcesFileData" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ hse_docs.resourcesFilePath }}
            </a>
          </p>
        </div>
    </div>
</form>

<br>

<blockquote>
    <h5 class="headings">SUPPLIER SUSTAINABILITY & ETHICS</h5>
</blockquote>

<form>
    <div *ngIf="!isViewOnly">
      <h6 class="instructions">
        As part of our sustainability and responsible sourcing initiative, all vendors are 
        required to complete a Sustainability Checklist.
        Please click the link below to complete the checklist.
        Once completed, return to this form and confirm completion by ticking the checkbox below.
      </h6>
    </div>
  
    <h6 *ngIf="!isViewOnly">
        <a
          href="https://forms.office.com/Pages/ResponsePage.aspx?id=qJc-RVHkU0e16LAqaJ_ybu48M-JZVehEuppC_qEe8bdUNzA0MEE4WDg3TVZCREVIQklCNTlYTVcwVC4u"
          target="_blank"
          class="terms-link"
          rel="noopener noreferrer"
          aria-label="Sustainability Checklist"
        >
          Complete the Sustainability Checklist Here
          <i class="fas fa-external-link-alt" aria-hidden="true" style="margin-left: 4px;"></i>
        </a>
    </h6>
    
    <div *ngIf="isViewOnly">
      <h6 class="instructions">
        Vendor agreed to completing the 
        Sustainability Checklist
        <!-- <a
          href="https://forms.office.com/Pages/ResponsePage.aspx?id=qJc-RVHkU0e16LAqaJ_ybu48M-JZVehEuppC_qEe8bdUNzA0MEE4WDg3TVZCREVIQklCNTlYTVcwVC4u"
          target="_blank"
          class="terms-link"
          rel="noopener noreferrer"
          aria-label="Sustainability Checklist"
        >
          Sustainability Checklist
          <i class="fas fa-external-link-alt" aria-hidden="true" style="margin-left: 4px;"></i>
        </a> -->
      </h6>
    </div>
  
    <p *ngIf="!isViewOnly">
      <label>
        <input type="checkbox" name="agreement" [(ngModel)]="agreedSustainability" (ngModelChange)="resetErrorMessage()" />
        <span>
          I confirm that I have completed the Sustainability Checklist. (Mandatory)
        </span>
      </label>
    </p>
</form>
  
